import type { InvoiceStatusType } from 'api/swagger';

export type { InvoiceStatusType } from 'api/swagger';

export const InvoiceStatus = {
  NeedAction: 'need_action',
  WaitingOriginal: 'waiting_original',
  OriginalSent: 'original_sent',
  Waiting: 'waiting',
  PartiallyPaid: 'partially_paid',
  Problem: 'problem',
  Loss: 'loss',
  Completed: 'completed',
  Cancelled: 'cancelled',
  LegalActions: 'legal_actions',
} satisfies Record<string, InvoiceStatusType>;

export const InvoiceStatuses: InvoiceStatusType[] = [
  InvoiceStatus.NeedAction,
  InvoiceStatus.WaitingOriginal,
  InvoiceStatus.OriginalSent,
  InvoiceStatus.Waiting,
  InvoiceStatus.PartiallyPaid,
  InvoiceStatus.Problem,
  InvoiceStatus.Loss,
  InvoiceStatus.Completed,
  InvoiceStatus.Cancelled,
  InvoiceStatus.LegalActions,
];
